<template>
  <CButton class="btn-block btn-twitter" v-on="$listeners" :text="text">
    <i class="fa fa-twitter mr-2"></i>
  </CButton>
</template>

<script>
import CButton from "../partials/CButton";

export default {
  components: {
    CButton,
  },
  data() {
    return {
      text: this.$t("sign_in_dialog.button.twitter"),
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/variables";

.btn-twitter {
  background: $color-twitter-blue;
  color: white;

  &:hover {
    background: darken($color-twitter-blue, 10%);
  }
}
</style>
